var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 14.1667V15.8334H3.33329V14.1667C2.41246 14.1667 1.66663 14.9126 1.66663 15.8334C1.66663 16.7534 2.41246 17.5001 3.33329 17.5001C3.83413 17.5001 16.1658 17.5001 16.6666 17.5001C17.5875 17.5001 18.3333 16.7534 18.3333 15.8334C18.3333 14.9126 17.5875 14.1667 16.6666 14.1667Z",
    fill: "url(#paint0_linear_1927_52230)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2.01175C13.7067 2.47175 12.96 2.47175 12.5 2.01175C12.04 1.55175 11.2934 1.55175 10.8334 2.01175C10.3734 2.47175 9.62671 2.47175 9.16671 2.01175C8.70671 1.55175 7.96004 1.55175 7.50004 2.01175C7.04004 2.47175 6.29337 2.47175 5.83337 2.01175C5.37337 1.55175 4.62671 1.55175 4.16671 2.01175L3.67837 2.50008C3.45754 2.72091 3.33337 3.02091 3.33337 3.33341V15.8334H16.6667V3.33341C16.6667 3.02091 16.5425 2.72091 16.3217 2.50008L15.8334 2.01175C15.3734 1.55175 14.6267 1.55175 14.1667 2.01175Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 7.49992H6.66671C6.20587 7.49992 5.83337 7.12659 5.83337 6.66659C5.83337 6.20659 6.20587 5.83325 6.66671 5.83325H13.3334C13.7942 5.83325 14.1667 6.20659 14.1667 6.66659C14.1667 7.12659 13.7942 7.49992 13.3334 7.49992Z",
    fill: "url(#paint1_linear_1927_52230)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.8334H6.66671C6.20587 10.8334 5.83337 10.4601 5.83337 10.0001C5.83337 9.54008 6.20587 9.16675 6.66671 9.16675H10C10.4609 9.16675 10.8334 9.54008 10.8334 10.0001C10.8334 10.4601 10.4609 10.8334 10 10.8334Z",
    fill: "url(#paint2_linear_1927_52230)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.8334C13.7936 10.8334 14.1667 10.4603 14.1667 10.0001C14.1667 9.53984 13.7936 9.16675 13.3333 9.16675C12.8731 9.16675 12.5 9.53984 12.5 10.0001C12.5 10.4603 12.8731 10.8334 13.3333 10.8334Z",
    fill: "url(#paint3_linear_1927_52230)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667H6.66671C6.20587 14.1667 5.83337 13.7933 5.83337 13.3333C5.83337 12.8733 6.20587 12.5 6.66671 12.5H10C10.4609 12.5 10.8334 12.8733 10.8334 13.3333C10.8334 13.7933 10.4609 14.1667 10 14.1667Z",
    fill: "url(#paint4_linear_1927_52230)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.1667C13.7936 14.1667 14.1667 13.7936 14.1667 13.3333C14.1667 12.8731 13.7936 12.5 13.3333 12.5C12.8731 12.5 12.5 12.8731 12.5 13.3333C12.5 13.7936 12.8731 14.1667 13.3333 14.1667Z",
    fill: "url(#paint5_linear_1927_52230)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1927_52230",
    x1: 9.99996,
    y1: 14.1667,
    x2: 9.99996,
    y2: 17.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1927_52230",
    x1: 10,
    y1: 5.83325,
    x2: 10,
    y2: 7.49992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1927_52230",
    x1: 8.33337,
    y1: 9.16675,
    x2: 8.33337,
    y2: 10.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1927_52230",
    x1: 13.3333,
    y1: 9.16675,
    x2: 13.3333,
    y2: 10.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1927_52230",
    x1: 8.33337,
    y1: 12.5,
    x2: 8.33337,
    y2: 14.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1927_52230",
    x1: 13.3333,
    y1: 12.5,
    x2: 13.3333,
    y2: 14.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvoice);
export default __webpack_public_path__ + "static/media/ic-invoice.bfae9e0ca18e3030376ddd23799680ff.svg";
export { ForwardRef as ReactComponent };